// extracted by mini-css-extract-plugin
export default {"fixed":"Addresses_fixed__wB6mv","tdata":"Addresses_tdata__T55RE","tlabel":"Addresses_tlabel__FTPfY"};